/* Keeps product history in this browser; card markup is refreshed from the storefront. */
class SRecentlyViewed extends HTMLElement {
  #abortController;

  connectedCallback() {
    const currentId = this.dataset.productId;
    const currentUrl = this.dataset.productUrl;
    if (!currentId || !currentUrl) return;

    const history = this.#readHistory();
    const previous = history.filter((item) => item.id !== currentId).slice(0, 4);
    this.#saveHistory([{ id: currentId, url: currentUrl }, ...history.filter((item) => item.id !== currentId)].slice(0, 12));
    if (!previous.length) return;

    this.#abortController = new AbortController();
    this.#load(previous);
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #readHistory() {
    let raw;
    try {
      raw = localStorage.getItem('sahla:recently-viewed:v1');
    } catch {
      try { raw = sessionStorage.getItem('sahla:recently-viewed:v1'); } catch { return []; }
    }
    try {
      const entries = JSON.parse(raw || '[]');
      return Array.isArray(entries)
        ? entries.filter((item) => item && typeof item.id === 'string' && typeof item.url === 'string').slice(0, 12)
        : [];
    } catch {
      return [];
    }
  }

  #saveHistory(entries) {
    const serialized = JSON.stringify(entries);
    try {
      localStorage.setItem('sahla:recently-viewed:v1', serialized);
    } catch {
      try { sessionStorage.setItem('sahla:recently-viewed:v1', serialized); } catch { /* Storage is unavailable. */ }
    }
  }

  async #load(previous) {
    const list = this.querySelector('[data-recently-viewed-list]');
    const section = this.querySelector('[data-recently-viewed-section]');
    if (!list || !section) return;

    const cards = await Promise.all(previous.map(async ({ id, url }) => {
      try {
        const address = new URL(url, window.location.origin);
        if (address.origin !== window.location.origin) return null;
        const response = await fetch(address, { credentials: 'same-origin', signal: this.#abortController.signal });
        if (!response.ok) return null;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (page.querySelector('s-recently-viewed')?.dataset.productId !== id) return null;
        const card = page.querySelector('template[data-recently-viewed-card]')?.content.firstElementChild;
        return card ? document.importNode(card, true) : null;
      } catch {
        return null;
      }
    }));

    if (this.#abortController.signal.aborted) return;
    const available = cards.filter(Boolean);
    if (!available.length) return;
    list.replaceChildren(...available);
    section.hidden = false;
  }
}

customElements.define('s-recently-viewed', SRecentlyViewed);
